import {BaseDto} from '../../../../common/src/lib/dtos/base.dto';
import {FirebaseNotificationSendRequirementsDto} from './firebaseNotificationSendRequirementsDto';

export class SendAppNotificationInitiateDto extends BaseDto {
    code: string;
    title: string;
    description: string;
    url: string;
    imageUrl: string;
    forceRun: boolean;
    specificEmails: string[];
    requirements: FirebaseNotificationSendRequirementsDto;

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

    constructor(code: string, title: string, description: string, url: string, imageUrl: string,
                requirements: FirebaseNotificationSendRequirementsDto, forceRun: boolean, specificEmails: string[]) {
        super();
        this.code = code;
        this.title = title;
        this.description = description;
        this.url = url;
        this.imageUrl = imageUrl;
        this.requirements = requirements;
        this.forceRun = forceRun;
        this.specificEmails = specificEmails;
    }
}
